<template>
    <div class="title-list-container">
        <!-- 搜索区域 -->
        <div class="search-bar">
            <el-input v-model="searchForm.title" placeholder="请输入标题" clearable size="large"
                style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
                <template #prefix>
                    <el-icon>
                        <Search />
                    </el-icon>
                </template>
            </el-input>

            <el-button type="primary" size="large" @click="handleSearch">
                <el-icon>
                    <Search />
                </el-icon>
                搜索
            </el-button>
        </div>

        <!-- 标题列表 -->
        <el-table :data="recordList" stripe style="width: 100%; margin-top: 20px">
            <el-table-column prop="title" label="主标题" width="250" />
            <el-table-column prop="subtitle" label="副标题" width="200" />
            <el-table-column prop="bottomContent" label="底部内容" width="200" />
            <el-table-column prop="subtitles" label="字幕" width="200" />
            <el-table-column prop="use_num" label="使用次数" width="120" />
            <el-table-column prop="prohibited_words" label="违禁词" width="150" />
            <el-table-column prop="status" label="状态" width="120">
                <template #default="{ row }">
                    <el-tag :type="row.status === 2 ? 'success' : 'warning'">
                        {{ row.status === 2 ? '正常' : '待审核' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="180" />

            <el-table-column label="操作" width="220" fixed="right">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="handleEdit(scope.row)">
                        <el-icon>
                            <Edit />
                        </el-icon>
                        编辑
                    </el-button>
                    <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
                        <el-icon>
                            <Delete />
                        </el-icon>
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
                :total="pagination.total" :page-sizes="[10, 20, 30, 50]"
                layout="total, sizes, prev, pager, next, jumper" @size-change="fetchRecordList"
                @current-change="fetchRecordList" />
        </div>

        <!-- 编辑对话框 -->
        <el-dialog v-model="editDialogVisible" title="编辑文案" width="600px" :close-on-click-modal="false"
            :append-to-body="true" class="child-dialog">
            <el-form :model="editForm" label-width="100px">
                <el-form-item label="主标题">
                    <el-input v-model="editForm.title" autocomplete="off" />
                </el-form-item>
                <el-form-item label="副标题">
                    <el-input v-model="editForm.subtitle" autocomplete="off" />
                </el-form-item>
                <el-form-item label="底部内容">
                    <el-input v-model="editForm.bottomContent" autocomplete="off" />
                </el-form-item>
                <el-form-item label="字幕">
                    <el-input v-model="editForm.subtitles" type="textarea" :rows="3" autocomplete="off" />
                </el-form-item>
                <el-form-item label="违禁词">
                    <el-input v-model="editForm.prohibited_words" autocomplete="off" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-radio-group v-model="editForm.status">
                        <el-radio :label="1">待审核</el-radio>
                        <el-radio :label="2">正常</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="使用次数">
                    <el-input-number v-model="editForm.use_num" :min="0" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="handleUpdate">确认</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import { Search, Edit, Delete } from '@element-plus/icons-vue';

export default {
    components: { Search, Edit, Delete },
    props: {
        taskId: { type: Number, required: true },
        storeId: { type: Number, required: true }
    },
    data() {
        return {
            loading: false,
            searchForm: { title: '' },
            recordList: [],
            pagination: { page: 1, pageSize: 10, total: 0 },
            editDialogVisible: false,
            editForm: { id: null, title: '', subtitle: '', bottomContent: '', subtitles: '', prohibited_words: '', status: 1, use_num: 0 }
        }
    },
    mounted() { this.fetchRecordList(); },
    methods: {
        async fetchRecordList() {
            this.loading = true;
            try {
                const params = { action: this.searchForm.title ? 'search_by_task' : 'list_by_task', store_id: this.storeId, ai_task_id: this.taskId, page: this.pagination.page, page_size: this.pagination.pageSize };
                if (this.searchForm.title) params.title = this.searchForm.title;
                const { data } = await axios.post(`${config.BASE_URL}/shop/api/wenan_create_record.php`, params);
                if (data.data) { this.recordList = data.data; this.pagination.total = data.pagination?.total || data.data.length; }
            } catch (error) { this.$message.error('获取文案列表失败'); console.error('获取文案列表错误:', error); }
            finally { this.loading = false; }
        },
        handleSearch() { this.pagination.page = 1; this.fetchRecordList(); },
        handleEdit(row) { this.editForm = { id: row.id, title: row.title, subtitle: row.subtitle || '', bottomContent: row.bottomContent || '', subtitles: row.subtitles || '', prohibited_words: row.prohibited_words || '', status: row.status, use_num: row.use_num }; this.editDialogVisible = true; },
        async handleUpdate() {
            try {
                const { data } = await axios.post(`${config.BASE_URL}/shop/api/wenan_create_record.php`, { action: 'update', id: this.editForm.id, store_id: this.storeId, ai_task_id: this.taskId, title: this.editForm.title, subtitle: this.editForm.subtitle, bottomContent: this.editForm.bottomContent, subtitles: this.editForm.subtitles, prohibited_words: this.editForm.prohibited_words, status: this.editForm.status, use_num: this.editForm.use_num });
                if (data.success) { this.$message.success('更新成功'); this.editDialogVisible = false; this.fetchRecordList(); }
                else { this.$message.error(data.error || '更新失败'); }
            } catch (error) { this.$message.error('更新失败'); console.error('更新错误:', error); }
        },
        async handleDelete(id) {
            this.$confirm('确定要删除该文案吗？', '警告', { confirmButtonText: '确认删除', cancelButtonText: '取消', type: 'warning' }).then(async () => {
                try {
                    const { data } = await axios.post(`${config.BASE_URL}/shop/api/wenan_create_record.php`, { action: 'delete', id: id, store_id: this.storeId });
                    if (data.success) { this.$message.success('删除成功'); this.fetchRecordList(); }
                    else { this.$message.error(data.error || '删除失败'); }
                } catch (error) { this.$message.error('删除失败'); console.error('删除错误:', error); }
            }).catch(() => { });
        }
    }
}
</script>

<style scoped>
.title-list-container {
    padding: 20px;
    background: transparent !important;
    color: #e0e0e0;
}

.search-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 20px;
    padding: 16px;
    background: rgba(18, 14, 33, 0.4) !important;
    backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(157, 78, 221, 0.2);
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

:deep(.el-table) {
    --el-table-bg-color: transparent !important;
    --el-table-tr-bg-color: transparent !important;
    --el-table-header-bg-color: transparent !important;
    --el-table-row-hover-bg-color: rgba(157, 78, 221, 0.1) !important;
    --el-table-current-row-bg-color: rgba(157, 78, 221, 0.15) !important;
    --el-table-stripe-row-bg-color: rgba(157, 78, 221, 0.05) !important;
    --el-table-border-color: rgba(157, 78, 221, 0.2) !important;
    background-color: transparent !important;
    color: #e0e0e0;
}

:deep(.el-table__body-wrapper) {
    background-color: transparent !important;
}

:deep(.el-table__body tr) {
    background-color: transparent !important;
}

:deep(.el-table__body tr td) {
    background-color: transparent !important;
    border-bottom: 1px solid rgba(157, 78, 221, 0.1);
    color: #e0e0e0;
}

:deep(.el-table__body tr.el-table__row--striped td) {
    background-color: rgba(157, 78, 221, 0.05) !important;
}

:deep(.el-table__body tr:hover td) {
    background-color: rgba(157, 78, 221, 0.1) !important;
}

:deep(.el-table__header-wrapper th) {
    background: rgba(157, 78, 221, 0.2) !important;
    color: #fff !important;
    border-bottom: 1px solid rgba(157, 78, 221, 0.3) !important;
}


:deep(.el-pagination) {
    --el-pagination-bg-color: transparent;
}

:deep(.el-pagination .btn-prev),
:deep(.el-pagination .btn-next),
:deep(.el-pagination .el-pager li) {
    background: rgba(157, 78, 221, 0.1) !important;
    border: 1px solid rgba(157, 78, 221, 0.3) !important;
    color: #a0a0c0 !important;
    border-radius: 8px;
}

:deep(.el-pagination .btn-prev:hover),
:deep(.el-pagination .btn-next:hover),
:deep(.el-pagination .el-pager li:hover) {
    background: rgba(157, 78, 221, 0.2) !important;
    color: #c084fc !important;
}

:deep(.el-pagination .el-pager li.active) {
    background: linear-gradient(135deg, #6546b4, #9d4edd) !important;
    color: #fff !important;
}

:deep(.el-pagination__total),
:deep(.el-pagination__jump) {
    color: #a0a0c0 !important;
}
</style>